<div class="product-card">
	<div class="product-card__body">
		<div v-if="availability === availabilityValues.NEW" class="product-card__flag product-card__flag--new"><span>New</span></div>
		<div v-if="availability === availabilityValues.DISCONTINUED" class="product-card__flag product-card__flag--discontinued"><span>Discontinued</span></div>
		<div v-if="availability === availabilityValues.COMINGSOON" class="product-card__flag product-card__flag--coming-soon"><span>Coming Soon</span></div>
		<a :href="productDetailUrl" class="product-card__image-link" v-bind:class="secondaryImageUrl ? 'product-card__image-link--multiple' : ''">
			<div class="product-card__image-wrap" >
				<img :src="primaryImageUrl + '?$nhwProductThumbs$'" loading="lazy" class="product-card__image" :alt="displayName">
				<img v-if="secondaryImageUrl" loading="lazy" :src="secondaryImageUrl + '?$nhwProductThumbs$'" :alt="displayName" class="product-card__image-hover">
			</div>
			<div class="product-card__view-details">{{translations['ProductFiltering.ViewDetails']}} <i class="icon-arrow-circle-right"></i></div>
		</a>

		<div class="product-card__product-info">
			<a :href="productDetailUrl">
				<div class="product-card__family">{{displayName}}</div>
			</a>
		</div>
		<a href="#" @click="$emit('favoriteProductRemoved', $event, stockNumber)" class="product-card__wishlist-toggle js-save-for-later" v-bind:class="isFavorites===true ? 'state-favorited' :''" :data-modelnumber="stockNumber">
			<i class="icon-favorite-outline" v-bind:class="isFavorites ? 'state-checked' : ''"></i>
		</a>
		<div class="product-card__finish-footer">
			<div class="product-card__finish-swatch-list" v-if="alternateFinishes.length">
				<ul class="finish-swatch-list finish-swatch-list--mini">
					<template v-for="(alternateFinish, index) in alternateFinishes">
						<template v-if="index <= 3"><!-- zero based index. actually checking for 4 -->
							<li class="finish-swatch-list__item">
								<div class="finish-swatch" v-bind:class="finish && finish.name && alternateFinish.finish.name === finish.name ? 'state-selected' : ''">
									<a href="#" @click="(e) => setProductCardFinish(e, alternateFinish)" class="js-finish-swatch finish-swatch__link " data-model="847087_c1" data-finish-name="Black">
										<img loading="lazy" :src="alternateFinish.finish.thumbnailUrl + '?$nhwSwatchThumb$'" class="finish-swatch__img">
										<div class="finish-swatch__name">{{alternateFinish.finish.name}}</div>
									</a>
								</div>
							</li>
						</template>
						<template v-if="index === 4">
							<li class="finish-swatch-list__item">
								<div class="finish-swatch-list__view-more">
									<a :href="productDetailUrl" class="finish-swatch-list__view-more-circle">+</a>
								</div>
							</li>
						</template>
					</template>
				</ul>
			</div>
			<div v-if="finish" class="product-card__active-swatch" v-bind:class="alternateFinishes.length > 1 ? 'product-card__active-swatch--multiple' :''">
				<div class="product-card__single-finish js-swatch-parent">
					<div class="finish-swatch state-selected">
						<div class="finish-swatch__link ">
							<img loading="lazy" :src="finish.thumbnailUrl + '?$nhwSwatchThumb$'" class="finish-swatch__img">
						</div>
					</div>
				</div>
				<div class="product-card__swatch-info js-swatch-info-parent">
					<div class="product-card__swatch-info-title js-active-finish">
						{{finish.name}}
					</div>
					<a v-if="alternateFinishes.length > 1" href="#" class="product-card__swatch-info-more js-more-swatches">
						+ More
					</a>
				</div>
			</div>
		</div>

	</div>
</div>
